import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '@app/shared/services';
import { UserRepository, UserService } from '@state/user';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);
  private userRepository = inject(UserRepository);
  private userService = inject(UserService);

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    let loggedIn = this.authService.loggedIn();

    if (loggedIn) {
      if (!this.userRepository.getHasFetchedUser()) this.userService.setUserFromAuth();
      return true;
    } else {
      let redirectUrl = window.location.href;
      void this.router.navigate(['/login'], { queryParams: { redirectUrl } });
      return false;
    }
  }
}
